import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  SimpleChanges,
  ViewChild,
  inject
} from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MenuStickComponent } from '../menu-stick/menu-stick.component';
import { ModalContactoFacultadComponent, ContactModalData } from '../../components/modal-contacto-facultad/modal-contacto-facultad.component';

@Component({
  selector: 'app-facultad-portada',
  standalone: true,
  imports: [CommonModule, MenuStickComponent],
  templateUrl: './facultad-portada.component.html',
  styleUrl: './facultad-portada.component.scss'
})
export class FacultadPortadaComponent {
  @Input() data: any;
  @Input() path: string;
  @Input() pathMob: string;
  @Input() itemCarrouselHeader: any;
  @Input() title: string;
  @Input() language: string;
  isMob: boolean
  isContactModalOpen = false;
  @ViewChild('videoPlayer') videoPlayer: any;
  @ViewChild('videoPlayerMob') videoPlayerMob: any;


  constructor( private renderer: Renderer2, private el: ElementRef) { }

  ngOnInit(): void { }
  

  @HostListener('window:resize', [])
  onResize(): void {
    this.checkScreenWidth();
  }


  ngAfterViewInit() {
    setTimeout(() => {
      const element = this.el.nativeElement.querySelector('#magic');
      if (element) {
        this.renderer.addClass(element, 'twisterInDown');
      }
      this.checkScreenWidth()

    }, 100);

    if (this.videoPlayer) {
      this.videoPlayer.nativeElement.muted = true
      this.videoPlayer.nativeElement.play();
    }
    if (this.videoPlayerMob) {
      this.videoPlayerMob.nativeElement.muted = true
      this.videoPlayerMob.nativeElement.play();
    }

    this.checkScreenWidth()

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.checkScreenWidth();
  }

  private checkScreenWidth() {
    this.isMob = (window.innerWidth <= 768);
  }
  createLink(item) {
    let url = environment.apiUrl + item
    return url
  }

  get showContactButton(): boolean {
    const cover = this.data?.newCover || {};
    return Boolean(
      cover.mostrarBotonContacto ??
      cover.mostrar_boton_contacto ??
      cover.showContactButton ??
      cover.show_contact_button ??
      cover.checkContacto ??
      cover.check_contacto ??
      cover.check_contact_button ??
      this.data?.mostrarBotonContacto ??
      this.data?.showContactButton ??
      this.data?.checkContacto ??
      this.data?.check_contacto
    );
  }

  get contactButtonColor(): string {
    return this.data?.venue?.color || '#6849B5';
  }

  get contactModalData(): ContactModalData | undefined {
    return this.data?.contactModal || this.data?.contactModalData;
  }

  openContactModal(): void {
    this.isContactModalOpen = true;
  }

  closeContactModal(): void {
    this.isContactModalOpen = false;
  }
}
